(ns frontend.view.components.ratings
  (:require [common.localization :as loc]
            [frontend.view.components.account :as account]
            [clojure.string :as string]
            [frontend.bootstrap.components :as rbs]
            [frontend.state.current-session :as session]))

(def scale (range 1 6))
(def scale-count (count scale))
(def step (->> scale-count (/ 1)))

(defn round-average [average]
  (if (number? average)
    (.toFixed average 1)
    (when-not (session/is-read-only-user?)
      (loc/tr :add-rating))))

(defn ratings-stars-view [{:keys [value on-change account]}]
  [:div.oppo-ratings-stars
   (doall (for [i scale]
            [:i.fas.fa-star.oppo-ratings-stars__star
             {:key      i
              :class    [(string/join " "
                                      [(if (< (get value (:db/id account)) (* i step))
                                         "oppo-ratings-stars__star--dimmed")
                                       "oppo-ratings-stars__star--clickable"])]
              :on-click (fn [e]
                          (on-change (assoc value (:db/id account) (* i step)) e))}
             ]))])

(defn ratings-view [{:keys [value accounts on-change]}]
  [:div.container.px-4
   [:div.grid.grid-cols-10.gap-4
    [:div
     {:class "col-span-5"}
     [:div.oppo-ratings-overall
      [:span.oppo-ratings-overall__score
       (if (> (count value) 0)
         (round-average (/ (reduce + (map #(* scale-count %) (vals value)))
                           (count value)))
         [:span.oppo-rating-missing (loc/tr :oppo/add-rating)])]
      [:span.oppo-ratings-overall__info
       (loc/tr :average-is-calculated-from-available-ratings)]]]
    [:div
     {:class "col-span-5"}
     [:div.oppo-ratings-details
      (doall (for [account accounts]
               [:div.oppo-ratings-details-row
                {:key (:db/id account)}
                [account/account-view {:value account
                                       :name? true}]
                [ratings-stars-view {:value     value
                                     :on-change on-change
                                     :account   account}]]))]]]])
